import React from 'react';

import { Meta } from '$partials/global';
import * as Pages from './union';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').UnionPage}
 */
const UnionPage = (props) => {
    if (!props.data?.page?.__typename) {
        return null;
    }

    const Component = Pages[props.data?.page?.__typename];
    if (!Component) { return null; }

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription || props.data?.page?.listingText || props.data?.page?.standfirst || props.data?.page?.articleStandfirst}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page}
                title={props.data?.page?.__typename === 'Home' ? 'Business Leader' : props.data?.page?.title} />
            <Component { ...props } />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default UnionPage;
